import { render, staticRenderFns } from "./PackageDescriptorUpdate.vue?vue&type=template&id=8f8e3496&"
import script from "./PackageDescriptorUpdate.vue?vue&type=script&lang=js&"
export * from "./PackageDescriptorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports